import { TransactionType } from '@seapoint/server/enums';
import { exhaustiveCheck } from './exhaustive-check';

export const getTransactionTypeDescription = (transactionType: TransactionType) => {
  switch (transactionType) {
    case TransactionType.CARD_PAYMENT:
      return 'Card payment';
    case TransactionType.CARD_REFUND:
      return 'Card refund';
    case TransactionType.CARD_CHARGEBACK:
      return 'Chargeback';
    case TransactionType.PAYMENT:
      return 'Payment';
    case TransactionType.PAYMENT_REFUND:
      return 'Payment refund';
    case TransactionType.PAYMENT_FEE:
      return 'Payment fee';
    case TransactionType.TAX:
      return 'Tax';
    case TransactionType.PAYOUT:
      return 'Payout';
    case TransactionType.EXCHANGE:
      return 'Exchange';
    case TransactionType.EXCHANGE_FEE:
      return 'Exchange fee';
    case TransactionType.DIRECT_DEBIT:
      return 'Direct debit';
    case TransactionType.TRANSFER:
      return 'Bank transfer';
    case TransactionType.REFUND:
      return 'Refund';
    case TransactionType.FEE:
      return 'Fee';
    case TransactionType.OTHER:
      return 'Other';
    default:
      return exhaustiveCheck(transactionType);
  }
};
